import { render, staticRenderFns } from "./DtpTable.vue?vue&type=template&id=529a4510&"
import script from "./DtpTable.vue?vue&type=script&lang=js&"
export * from "./DtpTable.vue?vue&type=script&lang=js&"
import style0 from "./DtpTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports